'use strict';

var AppDispatcher = require('../AppDispatcher'),
    SearchStampStore = require('../stores/SearchStampStore'),
    SearchUserStore = require('../stores/SearchUserStore'),
    SearchZineStore = require('../stores/SearchZineStore'),
    RouterStore = require('../stores/RouterStore'),
    ActionTypes = require('../constants/ActionTypes'),
    { createStore } = require('../utils/StoreUtils'),
    update = require('react/lib/update');

var _history = [];

function clearHistory() {
  _history = [];
}

function addToHistory(terms) {
  var index = _history.indexOf(terms);
  if (index > -1) {
    _history = update(_history, {
      $splice: [[index, 1]]
    });
  }

  _history = update(_history, {
    $splice: [[0, 0, terms]]
  });
}

function hasDataFor(terms) {
  return SearchStampStore.getPageCount(terms) > 0 &&
         SearchUserStore.getPageCount(terms) > 0 &&
         SearchZineStore.getPageCount(terms) > 0;
}

var SearchStore = createStore({
  getTermsFromRoute() {
    var terms = RouterStore.getRouterState().query.q || '';
    return terms.trim();
  },

  getLastTermsWithData() {
    for (let terms of _history) {
      if (hasDataFor(terms)) {
        return terms;
      }
    }

    return '';
  }
});

AppDispatcher.register(function (payload) {
  AppDispatcher.waitFor([
    SearchStampStore.dispatchToken,
    SearchUserStore.dispatchToken,
    SearchZineStore.dispatchToken,
    RouterStore.dispatchToken
  ]);

  var { action } = payload;

  switch (action.type) {
  case ActionTypes.CHANGE_ROUTE:
    var terms = SearchStore.getTermsFromRoute();
    if (terms.length > 0) {
      addToHistory(terms);
    } else {
      clearHistory();
    }
    SearchStore.emitChange();
    break;

  case ActionTypes.REQUEST_STAMP_SEARCH_SUCCESS:
  case ActionTypes.REQUEST_USER_SEARCH_SUCCESS:
  case ActionTypes.REQUEST_ZINE_SEARCH_SUCCESS:
    SearchStore.emitChange();
    break;
  }
});

module.exports = SearchStore;


/** WEBPACK FOOTER **
 ** ./stores/SearchStore.js
 **/